import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InformationSavedComponent } from './information-saved/information-saved.component';
import { ThrowStmt } from '@angular/compiler';
import { Endorse } from '../../shared/endorse.model';

@Component({
  selector: 'app-saved-endorse',
  templateUrl: './saved-endorse.component.html',
  styleUrls: ['./saved-endorse.component.scss']
})
export class SavedEndorseComponent implements OnInit {

  @ViewChild('yes') informationSavedComponent: InformationSavedComponent;
  @ViewChild('no') noInformationSavedComponent: InformationSavedComponent;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SavedEndorseComponent>) {  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close(0);
  }

  accept() {
    const endorse = new Endorse();
    let subject;
    if (this.noInformationSavedComponent) {
      if (this.informationSavedComponent) {
        subject = this.informationSavedComponent.subjects.concat(this.noInformationSavedComponent.subjects);
        endorse.justificacionAvalados = this.informationSavedComponent.jusFormControl.value;
        endorse.numeroActa = this.informationSavedComponent.numeFormControl.value;
        const d: Date = this.informationSavedComponent.dateFormControl.value;
        const locaDate = d.toLocaleString().split('/');
        const dia = Number(locaDate[0]) <= 9 ? '0' + locaDate[0] : locaDate[0];
        const mes = Number(locaDate[1]) <= 9 ? '0' + locaDate[1] : locaDate[1];
        const year = d.getFullYear();
        endorse.fechaActa = dia + '-' + mes + '-' + year;
        endorse.autorizador = this.informationSavedComponent.autFormControl.value;
      } else {
        subject = this.noInformationSavedComponent.subjects;
      }
      endorse.justificacionNoAvalados = this.noInformationSavedComponent.jusFormControl.value;
    } else {
      subject = this.informationSavedComponent.subjects;
      endorse.justificacionAvalados = this.informationSavedComponent.jusFormControl.value;
      endorse.numeroActa = this.informationSavedComponent.numeFormControl.value;
      const d: Date = this.informationSavedComponent.dateFormControl.value;
      const locaDate = d.toLocaleString().split('/');
      const dia = Number(locaDate[0]) <= 9 ? '0' + locaDate[0] : locaDate[0];
      const mes = Number(locaDate[1]) <= 9 ? '0' + locaDate[1] : locaDate[1];
      const year = d.getFullYear();
      endorse.fechaActa = dia + '-' + mes + '-' + year;
      endorse.autorizador = this.informationSavedComponent.autFormControl.value;
    }
    endorse.materias = subject;
    console.log(endorse);
    this.dialogRef.close(endorse);
  }

  validateField() {
    if (this.data.yesEndoerses.length > 0) {
      if (this.validateYes()) {
        return true;
      } else {
        if (this.data.noEndoerses.length > 0) {
          if (this.validateNo()) {
            return true;
          }
      }
      }
  } else if (this.data.noEndoerses.length > 0) {
    if (this.validateNo()) {
      return true;
    }
  }
  return false;
  }

  private validateYes() {
    if (this.informationSavedComponent) {
        if (!this.informationSavedComponent.autFormControl.value
            || !this.informationSavedComponent.numeFormControl.value
            || !this.informationSavedComponent.dateFormControl.value) {
              return true;
        }
    }
  }

  private validateNo() {
    if (this.noInformationSavedComponent) {
      if (!this.noInformationSavedComponent.jusFormControl.value) {
            return true;
      }
  }
  }

}
